<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('General') }}</h1>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                    <router-link
                        class="btn btn-gray shadow-sm rounded"
                        to="/workspace/admin/settings"
                    >
                        {{ $t('Back') }}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6">
                <loading :status="loading"/>
                <form @submit.prevent="save">
                    <div class="shadow sm:rounded sm:overflow-hidden">
                        <div class="px-4 py-5 bg-white sm:p-6">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="app_url">{{ $t('Site url') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="app_url"
                                            v-model="app_url"
                                            :placeholder="$t('App url')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                            type="url"
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="app_name">{{ $t('Site name') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="app_name"
                                            v-model="app_name"
                                            :placeholder="$t('Site name')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="app_admin_notifications">{{ $t('Send all E-Mail Notifications to Admin') }}</label>
                                    <input-switch
                                        id="app_admin_notifications"
                                        v-model="app_admin_notifications"
                                        :disabled-label="$t('Admin notifications are diabled')"
                                        :enabled-label="$t('System Admin get all E-Mail Notifications')"
                                    ></input-switch>
                                    <div class="mt-2 relative text-xs text-gray-500">
                                        {{ $t('All E-Mail notifications are additionally sent to the main administrator') }}.
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="app_https">{{ $t('Force HTTPS') }}</label>
                                    <input-switch
                                        id="app_https"
                                        v-model="app_https"
                                        :disabled-label="$t('The site will load from any available protocol')"
                                        :enabled-label="$t('The site will be forced to load with https')"
                                    ></input-switch>
                                    <div class="mt-2 relative text-xs text-gray-500">
                                        {{ $t('Force the loading of the site using HTTPS, to improve the security and SEO positioning of the site') }}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 py-3 stage-footer-surface text-right sm:px-6">
                            <div class="inline-flex">
                                <button class="btn btn-green rounded shadow-sm" type="submit">
                                    {{ $t('Save settings') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "general",
    data() {
        return {
            loading: true,
            app_url: null,
            app_name: null,
            app_admin_notifications: null,
            app_https: null,
        }
    },
    mounted() {
        this.get();
    },
    methods: {
        get() {
            const self = this;
            axios.get('api/workspace/admin/settings/general').then(function (response) {
                self.app_url = response.data.app_url;
                self.app_name = response.data.app_name;
                self.app_admin_notifications = response.data.app_admin_notifications;
                self.app_https = response.data.app_https;
                self.loading = false;
            }).catch(function () {
                this.$router.push('/workspace/admin/settings');
            });
        },
        save() {
            const self = this;
            self.loading = true;
            axios.post('api/workspace/admin/settings/general', {
                app_url: self.app_url,
                app_name: self.app_name,
                app_admin_notifications: self.app_admin_notifications,
                app_https: self.app_https
            }).then(function () {
                self.loading = false;
                self.$store.commit('patchSettings', {
                    name: self.app_name,
                });
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Settings updated successfully').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        }
    }
}
</script>
